<div class="box-filter">
  <div
    @click="onFilter"
    v-outside="outsideClick"
    @keydown="handleKeyDown"
    @keydown.stop
    tabindex="0"
    :class="{'active' : isDropdown}"
    class="row c-filter"
  >
    <div class="icon-filter-button">
      <img :src="require('@/assets/icons/sidebars/filter.svg')" alt="" />
    </div>
    <div
      v-if="isDropdown"
      :class="{'c-filter-dropdown-active' : isDropdown}"
      class="c-filter-dropdown"
    >
      <div @click.stop class="c-filter-dropdown-item">
        <slot name="filter"></slot>
      </div>
    </div>
  </div>
</div>
